import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  Spin,
  Space,
  Modal,
} from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

export default function ExpenseCategoryModal({
  visible,
  modalClose,
  fetchCategoryList,
  data,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const handleModalClose = () => {
    modalClose();
  };
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        category_name: data?.category_name,
        sub_categories: data?.sub_categories,
      });
    }
  }, [data, form]);
  const handleSubmit = (values) => {
    const apiUrl = data
      ? `${config.baseUrl}/budget/update_expense_category/${data.id}/`
      : `${config.baseUrl}/budget/create_expense_category/`;

    const request = data ? axios.patch : axios.post;

    setLoading(true);

    request(apiUrl, values, {
      headers: authHeader(),
    })
      .then((response) => {
        setLoading(false);

        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: "Success",
            text: response.data?.message || "Saved successfully",
            confirmButtonText: "Ok",
            icon: "success",
          }).then(() => {
            handleModalClose();
            fetchCategoryList();
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);

        Swal.fire({
          title: "Error",
          text: error?.response?.data?.error || "Something went wrong",
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };

  return (
    <Modal
      title="Expense Category"
      open={visible}
      onCancel={handleModalClose}
      footer={false}
      width="60%"
    >
      <div className="farmerDashboard">
        <div className="pt-5" style={{ width: "95%", margin: "auto" }}>
          <div
            className="shadow-sm p-3"
            style={{ border: "1px solid #46604A" }}
          >
            <Form
              form={form}
              color="#46604A"
              onFinish={handleSubmit}
              layout="vertical"
            >
              <div className="d-flex gap-2 justify-content-between">
                <Col span={8}>
                  <Form.Item>
                    <Input
                      className="text-center custom-placeholder-color"
                      placeholder="Category Name"
                      disabled
                      style={{ color: "#46604A", borderColor: "#46604A" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item name="category_name">
                    <Input
                      className="text-center"
                      placeholder="Enter category name"
                      style={{ color: "#46604A", borderColor: "#46604A" }}
                    />
                  </Form.Item>
                </Col>
              </div>

              <Form.List name="sub_categories">
                {(fields, { add, remove }) => (
                  <div
                    className="p-3 mb-5"
                    style={{ color: "#46604A", border: "1px solid #46604A" }}
                  >
                    <Row>
                      <Col lg={4}>
                        <Form.Item>
                          <Button
                            onClick={() => add()}
                            block
                            size="small"
                            icon={<PlusOutlined />}
                          >
                            Add Sub-Category
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>

                    {fields.map(({ key, name, ...restField }) => (
                      <Row
                        key={key}
                        gutter={[0, 16]} // ⭐ no horizontal gap, vertical gap only
                        align="middle"
                        className="mb-2"
                      >
                        {/* Label */}
                        <Col style={{ width: 200 }}>
                          <label style={{ fontWeight: 500 }}>
                            Sub-Category
                          </label>
                        </Col>

                        {/* Input + remove button tightly aligned */}
                        <Col>
                          <Space size={4} align="center">
                            {data?.sub_categories.length > 0 && (
                              <Form.Item
                                {...restField}
                                name={[name, "id"]}
                                style={{ marginBottom: 0 }}
                              >
                                <Input hidden/>
                              </Form.Item>
                            )}
                            <Form.Item
                              {...restField}
                              name={[name, "sub_category_name"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Sub Category Name Required",
                                },
                              ]}
                              style={{ marginBottom: 0 }}
                            >
                              <Input style={{ width: 200 }} />
                            </Form.Item>

                            {fields.length > 1 && (
                              <Button
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                              />
                            )}
                          </Space>
                        </Col>
                      </Row>
                    ))}
                  </div>
                )}
              </Form.List>

              <Form.Item className="d-flex justify-content-end ">
                <Button
                  htmlType="submit"
                  disabled={loading}
                  style={{ color: "#ffffff", backgroundColor: "#46604A" }}
                >
                  Submit
                  {loading && <Spin size="small" style={{ marginLeft: 8 }} />}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </Modal>
  );
}
